export default __webpack_public_path__ + "static/media/memorial-red.05a29faf.svg";